import { sessionState } from '@/app/sessionState';
import { config as appConfig } from '@/app/config';


export function fetchInterceptor() {
  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    let [resource, options = {}] = args;
    const token = sessionState.token;

    let url = typeof resource === 'string' ? resource : resource.url;

    // Map & authorize api requests 
    if (url.startsWith('https://api.adenin.com/')) {
      // Normalize URL to configured API host
      const originalUrl = url;
      url = url.replace('https://api.adenin.com', appConfig.API_URL);

      if (typeof resource === 'string') {
        resource = url;
      } else {
        // Keep Request object semantics (can't directly mutate resource.url reliably)
        // Create a new Request cloning existing one
        resource = new Request(url, resource);
      }

      if (!options.headers) {
        options.headers = {};
      }

      // Attach bearer token if we have one and caller didn't already provide it
      if (token && !options.headers['Authorization']) {
        options.headers['Authorization'] = `Bearer ${token}`;
      }

      // If no token (cookie / session based auth) OR we have a subject, include cookies
      if (!token || sessionState.sub) {
        if (!options.credentials) {
          options.credentials = 'include';
        }
      }

      // Provide x-subject header when available (mirrors createFetchRequest/fetchData logic)
      if (sessionState.sub && !options.headers['x-subject']) {
        options.headers['x-subject'] = sessionState.sub;
      }

      // Add content-type for non-GET requests if not present
      if (!options.headers['Content-Type'] && options.method && options.method !== 'GET') {
        options.headers['Content-Type'] = 'application/json';
      }

      // Optional debug
      // console.log('fetchInterceptor mapped', originalUrl, '->', url, 'opts', options);
    }

    return originalFetch(resource, options);
  };
}